module.exports = __webpack_public_path__ + "media/images/writer/community/sp-headline-about-maker@2x-8a97b4fd2524ca85a622e9b921803fb4.png";